<template>
  <v-col cols="12" sm="6" class="my-2 py-0">
    <v-card class="pa-2 grey lighten-5" flat>
      {{ texte }} : <b>{{ valeur }}</b>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    texte: {
      required: true,
    },

    valeur: {
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
